import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  inputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    width: '100%',
    maxWidth: 350,
  },
  dropdown: {
    marginTop: theme.spacing(1),
  },
  item: {
    cursor: 'pointer',
    padding: theme.spacing(1),
  },
  active: {
    backgroundColor: theme.palette.colors.lightTeal,
    borderRadius: 4,
    overflow: 'hidden',
  },
  error: {
    color: theme.palette.colors.red,
    marginLeft: theme.spacing(1),
  },
  button: {
    borderRadius: 4,
    fontSize: '1.3rem',
    margin: [30, 0],
    width: '100%',
    height: 'unset',
    '& svg': { height: '1.3rem', width: '1.3rem' },
    [theme.breakpoints.up('mobile')]: {
      width: 350,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/LocationQuestion/useStyles.js